import React, { useState, useEffect } from 'react'
import { AssetDeliveryContainer } from 'components/shared/AssetDelivery'
import { createGroups } from 'components/shared/AssetDelivery/utils'
import { useAssetDelivery } from '../AssetDeliveryContext'
import { useUploader } from './UploaderContext'
import effects from './effects'
import Dropzone from './Dropzone'
import UploadGroup from './UploadGroup'
import DeleteAllAssets from './DeleteAllAssets'
import FileInput from './FileInput'
import './index.scss'

const fileTypes = [/^image\/x-/i, /^image\/dng/i, /^image\/jpeg$/i]

export default function Uploader() {
  const { createAssets, updateAsset, deleteAsset } = useAssetDelivery()
  const { product, uploaders, dispatch } = useUploader()

  const groups = createGroups(uploaders)
  const [expandedGroupIndex, setExpandedGroupIndex] = useState<number | null>(
    null
  )

  useEffect(() => {
    dispatch({ type: 'ADD_INITIAL_ASSETS', assets: product.assetDeliveries })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const effectsProps = {
    dispatch,
    uploaders,
    createAssets,
    updateAsset,
    deleteAsset,
    concurrentUploads: 3,
    productId: product.id,
    preDefinedLabels: product.availablePhotoLabels,
  }

  effects.useOnUploadersToPrepare(effectsProps)
  effects.useOnUploadersToCreate(effectsProps)
  effects.useOnUploadersToUpload(effectsProps)
  effects.useOnUploadersToUpdate(effectsProps)
  effects.useOnUploadersToDelete(effectsProps)

  function addFiles(files: FileList | null) {
    if (!files) return
    const validFiles = Array.from(files)
      .filter((file) => {
        if (!fileTypes || fileTypes.length === 0) return true
        return fileTypes.some((regexp) => regexp.test(file.type))
      })
      .sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { numeric: true })
      )

    dispatch({
      type: 'ADD_FILE_UPLOADS',
      files: validFiles.map((file) => ({ file, asset: { isPrimary: true } })),
    })
  }

  return (
    <div className="uploader">
      <div className="controls">
        <FileInput onFiles={addFiles} />
        <DeleteAllAssets />
      </div>
      <Dropzone
        onFiles={addFiles}
        className={uploaders.length === 0 ? 'empty' : ''}
      >
        <AssetDeliveryContainer>
          {groups.map(([id, uploaders]: any, i: number) => (
            <UploadGroup
              key={id}
              group={id}
              uploaders={uploaders}
              isExpanded={expandedGroupIndex === i}
              setIsExpanded={(isExpanded) =>
                setExpandedGroupIndex(isExpanded ? i : null)
              }
              expandNextGroup={() => {
                setExpandedGroupIndex(i + 1 < groups.length ? i + 1 : 0)
              }}
              expandPreviousGroup={() => {
                setExpandedGroupIndex(i - 1 < 0 ? groups.length - 1 : i - 1)
              }}
            />
          ))}
        </AssetDeliveryContainer>
        <div className="drop-label">Dra og slipp filer her</div>
      </Dropzone>
    </div>
  )
}
